class SyntheticEvent {
  type: string;
  target: { name: string | undefined; value: string };

  constructor(type: string, name: string | undefined, value: string) {
    this.type = type;
    this.target = { name, value };
  }

  getName() {
    return this.target.name;
  }

  getValue() {
    return this.target.value;
  }
}

export { SyntheticEvent };
